﻿import { NgModule} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { SharedModule } from "../../../components/shared/shared.module";

// ------------------------------------------Start Service----------------------------------------------------------------------//
import { QuotationTableComponent } from "./table/quotation-table.component";
import { BsDatepickerModule  } from "ngx-bootstrap/datepicker";
import { InterceptorService } from "../../../service/components/authentication/interceptor.service";
import { QuotationItemService } from "../../../service/api/jubili/quotation-item.service";
import { NgbDatepickerModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
// ------------------------------------------End Service----------------------------------------------------------------------//

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        BrowserModule,
        RouterModule,
        SharedModule,
        BsDatepickerModule,
        NgbDatepickerModule,
        NgbModule
    ],
    declarations: [
        QuotationTableComponent
    ],
    exports: [
        QuotationTableComponent,
        SharedModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        QuotationItemService
    ]
})

export class QuotationItemModule { }
